import React, { useRef, useEffect, useState } from 'react';
import { apiKey } from '../services/storeGoogle_keys/storeGoogle_keys';

interface GenericModalProps {
  title: string;
  value: string;
  name: string;
  placeholder?: string;
  inputType?: string;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void; 
  handlePlaceSelectedCity: (place: google.maps.places.PlaceResult) => void; 
}

const Addresscomponet: React.FC<GenericModalProps> = ({
  value,
  name,
  placeholder = "Enter",  
  onChange,
  handlePlaceSelectedCity,
}) => {
  const [autocomplete, setAutocomplete] = useState<google.maps.places.Autocomplete | null>(null);
  const [rows, setRows] = useState(1); // Default rows
  const inputRef = useRef<HTMLTextAreaElement>(null); // Updated to HTMLTextAreaElement

  useEffect(() => {
    if (!window.google || !inputRef.current) return;

    const autocompleteInstance = new window.google.maps.places.Autocomplete(
      inputRef.current as unknown as HTMLInputElement, // Type cast to HTMLInputElement for compatibility
      {
        types: ["geocode"], 
        componentRestrictions: { country: "us" },
      }
    );

    setAutocomplete(autocompleteInstance);

    autocompleteInstance.addListener("place_changed", () => {
      const place = autocompleteInstance.getPlace();
      if (place) {
        console.log(place,"placeplaceplaceplaceplace")
        handlePlaceSelectedCity(place);
      }
    });
  }, [apiKey]);

  const handleResize = () => {
    if (inputRef.current) {
      inputRef.current.style.height = 'auto';

      inputRef.current.style.height = `${inputRef.current.scrollHeight}px`;
    }
  };

  useEffect(() => {
    handleResize();
  }, [value]);

  console.log(value,"valuelllllllll")
  return (
    <div className="gap8px">
      <textarea
        ref={inputRef}
        id=""
        cols={30}
        maxLength={100}
        rows={rows} 
        className="w-full p-2 text-md border border-gray-300 rounded-md hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
        placeholder={placeholder}
        value={value}
        name={name}
        onChange={onChange}
      />
    </div>
  );
};

export default Addresscomponet;
